@if (displayMode() === 'menuItem') {
  <button
    mat-menu-item
    [matMenuTriggerFor]="documentsMenu"
    (menuOpened)="menuOpened.emit(); searchInput.focus()"
  >
    <mat-icon>{{ iconName() }}</mat-icon>
    <span>Patient Document</span>
  </button>

  <mat-menu #documentsMenu="matMenu">
    <div class="h-[400px] overflow-y-auto p-0">
      <div
        class="sticky top-0 z-10 w-full border-b border-gray-200 bg-white px-4 py-2"
        (click)="$event.stopPropagation()"
        (keydown)="$event.stopPropagation()"
      >
        <mat-form-field class="w-full" subscriptSizing="dynamic">
          <input
            #searchInput
            matInput
            placeholder="Search Documents..."
            [formControl]="searchCtrl"
          />
        </mat-form-field>
      </div>
      <div class="menu-items-wrapper">
        <mat-progress-bar *ngIf="loading$ | async" mode="indeterminate" />
        @if (searchFilter.results$ | async; as documents) {
          @for (document of documents; track document.ref.id) {
            <button mat-menu-item (click)="documentClicked(document)">
              <div class="flex flex-col">
                <span>{{ document.name }}</span>
                <span class="text-xs text-gray-500">
                  {{ document.createdAt | moment | amDateFormat: dateFormat }}
                </span>
              </div>
            </button>
          } @empty {
            <div class="px-4 py-2 text-sm text-gray-500">
              @if (searchCtrl.value) {
                No documents found for "{{ searchCtrl.value }}"
              } @else {
                No documents available
              }
            </div>
          }
        }
      </div>
    </div>
  </mat-menu>
}

@if (displayMode() === 'inline') {
  <div class="flex flex-col gap-4 p-4">
    <div class="flex flex-row gap-4">
      <pt-search-field class="w-full">
        <input matInput placeholder="Search" [formControl]="searchCtrl" />
      </pt-search-field>

      <button mat-raised-button color="primary" (click)="createDocument()">
        Create
      </button>
    </div>

    <pr-empty-state
      *ngIf="emptyState$ | async"
      image="list"
      title="patient documents"
    />

    <ng-container *ngIf="searchFilter.results$ | async as documents">
      <mat-nav-list *ngIf="documents.length; else noSearchResults">
        <mat-progress-bar *ngIf="loading$ | async" mode="indeterminate" />
        <a
          *ngFor="let document of documents; trackBy: trackByDocument"
          mat-list-item
          [routerLink]="[document.ref.id]"
        >
          <div class="flex items-center justify-between">
            <div>{{ document.name }}</div>
            <div class="mat-caption">
              {{ document.createdAt | moment | amDateFormat: dateFormat }}
            </div>
          </div>
        </a>
      </mat-nav-list>
    </ng-container>
  </div>

  <ng-template #noSearchResults>
    <pr-empty-state
      *ngIf="(emptyState$ | async) === false"
      image="search"
      title="search results"
      [searchInputValue]="searchCtrl.value"
    />
  </ng-template>
}
